export type AreasName = "Hospedaje" | "Alimentos y Bebidas" | "Recepción"

export const tabs: {label: string, path: AreasName}[] = [
    { label: "Recepción", path: "Recepción" },
    { label: "Hospedaje", path: "Hospedaje" },
    { label: "Alimentos y Bebidas", path: "Alimentos y Bebidas" },
]
